var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlueIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0256A5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,30.9c-0.8,0-1.5-0.7-1.5-1.5V2.6c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v26.9 C17.5,30.3,16.8,30.9,16,30.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,17.5H2.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h26.9c0.8,0,1.5,0.7,1.5,1.5S30.3,17.5,29.4,17.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlueIcon);
export default __webpack_public_path__ + "static/media/add_blue_icon.fc7cd88cf42d50a1a940257120f73b05.svg";
export { ForwardRef as ReactComponent };